import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export type OrderFulfillmentBadgeType =
  | "Direct"
  | "Courier"
  | "Collection"
  | "Pallet"
  | "UPS"
  | "APC"
  | "Courier Pro"
  | "DX (Collection)"
  | "DX (Drop Off Point)"
  | "Parcelforce"
  | "Delivered by Sellar"
  | "Sellar Distribution";

export const OrderFulfillmentBadge = (
  props: BadgeProps & {
    type: OrderFulfillmentBadgeType;
  },
): React.ReactElement => (
  <Badge
    {...props}
    icon={"TRUCK"}
    className={twMerge("bg-gray-100 text-gray-700", props.className)}
  >
    {props.type}
  </Badge>
);
